var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsRightSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 68,
    viewBox: "0 0 63 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.856 39.6355L57.7455 44.0984L55.4706 51.1976L48.8946 50.939L54.2292 55.1527L51.1784 64.7366C23.8187 40.5356 62.9155 27.9729 62.9155 27.9729L59.4502 38.9763L51.856 39.6355Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4913 -6.0194C46.9717 -7.23907 52.705 -1.45118 54.8372 3.22262L48.5673 3.55654L46.0986 -0.685288L45.5789 3.72549L42.5906 3.89444L38.2846 -3.37577L37.4436 4.1563L35.7341 4.22039L33.4655 0.330518L32.989 4.30534L24.5418 4.80176C24.5918 4.88975 26.0609 -4.71175 36.4913 -6.0194Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7727 18.701L51.0721 28.4575C49.088 30.0396 46.9524 31.5722 44.7666 33.0545L38.1784 27.1796L38.2146 36.6917C31.465 39.622 24.4753 40.6817 18.4282 37.08C18.4282 37.08 20.8126 28.7657 26.9868 21.1844L31.7252 23.7831L29.7909 18.0788C32.0318 15.9383 34.575 13.9982 37.5202 12.4601L40.8567 20.28L44.0632 10.1385C50.2454 8.78064 57.6288 9.33731 66.5591 13.0711C66.5591 13.0711 62.018 18.6173 55.3482 24.684L49.7727 18.701Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsRightSmall);
export default __webpack_public_path__ + "static/media/palmLeafsRightSmall.6c1831c0cf716fed2cc7679548434832.svg";
export { ForwardRef as ReactComponent };